import React, { Component } from "react";
import { Link } from "react-router-dom";

import SignHeader from "../component/SignHeader";
import Header from "../component/Header";

import Button from "@material-ui/core/Button";

import "../scss/style.scss";
import "../scss/sign.scss";

import Dialog from "@material-ui/core/Dialog";

import cookie from 'react-cookie';
//LSB
import queryString from 'query-string';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');

//var DEBUG11=true;
var DEBUG11=false;

class Home extends Component {
	constructor(props) {
		super(props);

        //LSB
        const qvalue=queryString.parse(props.location.search);
        let from_url=qvalue.from_url;
        if(DEBUG11) console.log('from_url',from_url);

        if(from_url===undefined || from_url===null) {
           from_url="/";
        }

		this.state = {
			headerTitle: "더책",
            from_url: from_url,
            userid: '',
            passwd: '', orgid: '', self: this, loading: true, loadingorg: true, totalcount: 0, aaa: props, orglist: []
        };


        //alert(JSON.stringify(this.state));

		//this.handleUseridChange = this.handleUseridChange.bind(this);
		//this.handleUserpasswdChange = this.handleUserpasswdChange.bind(this);

		this.doOpenAlert = this.doOpenAlert.bind(this);
		this.doCloseAlert = this.doCloseAlert.bind(this);

        let orgID = cookie.load("orgid");

		fetch('/api/AB/getorglist')
			.then(response => response.json())
			.then(data => {
				//alert(JSON.stringify(data));
				this.setState({ totalcount: data.totalcount, orglist: data.lstresult, loadingorg: false });
				//this.state.orgid = data.lstresult[0].id;

                if (orgID !== null && orgID.length > 0 && orgID !== 0) {
                    this.state.orgid = orgID;
                } else {
                    this.state.orgid = data.lstresult[0].id;
                }
			});

		//this.state.userid = "qkseh5309";
		//this.state.passwd = "wjddbdnjs1!";

    }

	setCookie(userid, strdbid, orgid, logoncount, llendbookcount, orgname, sbc) {
		let d = new Date();
		d.setTime(d.getTime() + (12 * 60 * 60 * 1000));
		cookie.save("userid", userid, { path: "/", expires: d });
		cookie.save("userdbid", strdbid, { path: "/", expires: d });
		cookie.save("orgid", orgid, { path: "/", expires: d });
		cookie.save("orgname", orgname, { path: "/", expires: d });
		cookie.save("lc", logoncount, { path: "/", expires: d });
		cookie.save("lendc", llendbookcount, { path: "/", expires: d });
		cookie.save("sbc", sbc, { path: "/", expires: d });
		cookie.save("device_userid", userid, { path: "/", expires: d });
		cookie.save("device_userdbid", strdbid, { path: "/", expires: d });
		cookie.save("device_orgid", orgid, { path: "/", expires: d });
		cookie.save("device_orgname", orgname, { path: "/", expires: d });
		cookie.save("device_lc", logoncount, { path: "/", expires: d });
		cookie.save("device_lendc", llendbookcount, { path: "/", expires: d });
		cookie.save("device_sbc", sbc, { path: "/", expires: d });
	};

	dologin() {

		this.state.loading = true;
		var arg = {
			orgid: this.state.orgid,
			userid: this.state.userid,
			passwd: this.state.passwd
		};
		//let struserid = cookie.load("userid");
		//let struserdbid = cookie.load("userdbid");

		//alert(JSON.stringify(this.state));
		fetch(`api/AB/dologin`, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(arg)
		})
			.then(response => response.json())
			.then(data => {
				//alert(JSON.stringify(data));
				if (data.R.RC === 250) {
					this.state.self.setCookie(
						data.dicresult.userinfo.userid,
						data.dicresult.userinfo.id,
						data.dicresult.userinfo.orgid,
						data.dicresult.userlogoncount,
						data.dicresult.userlendcount,
						data.dicresult.userinfo.org.orgname,
						data.dicresult.sbc
                    );
                    //this.state.aaa.history.replace('/');
                    this.state.aaa.history.replace(this.state.from_url);
				}
				else {
					this.doOpenAlert();
				}
			});

	}

	handleUseridChange(e) {
		this.setState({ userid: e.target.value })
	}

	handleUserpasswdChange(e) {
		this.setState({ passwd: e.target.value })
	}

	handleOrgIDChange(e) {
		this.setState({ orgid: e.target.value })
	}

	doOpenAlert() {
		this.setState({ ...this.state, open: true });
		//this.state = { ...this.state, open: true };
	}

	doCloseAlert() {
		this.setState({ ...this.state, open: false });

		//this.state = { ...this.state, open: false };
	}

	signIn() {
		//alert(JSON.stringify(this.state));
		//alert('id is ' + this.state.userid + ' Password is ' + this.state.passwd);
		this.dologin();
	}

    dorender(orgID) {
		let ol = this.state.orglist;

		return (
			<React.Fragment>
				<h4 className="form-label1">도서관을 선택해 주세요</h4>
				<select className="form-select" onChange={this.handleOrgIDChange.bind(this)}>
                   
                    {ol.map(item => (
                        item.id === orgID
                            ? <option value={item.id} selected>{item.orgname}</option>
                            : <option value={item.id} >{item.orgname}</option>
					))}

				</select>
				<br/>
			</React.Fragment>
		)
    }

    logPageView() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location + "&orgid=" + cookie.load("orgid"));
    }

    render() {
        this.logPageView();

        let contents;
        let orgID = cookie.load("orgid");

        //if (orgID != null && orgID > 0 && orgID != 0) {
        //    contents = "";
        //}
        //else {
            contents = this.state.loadingorg === true
                ? (
                    <React.Fragment>
                        <h4 className="form-label">도서관 선택</h4>
                        <p className="section-description">도서관 목록을 가져오는 중 ...</p><br />
                    </React.Fragment>

                )
                : this.dorender(orgID);
        //}
		//let contents = this.state.loadingorg === true
		//	? (
		//		<React.Fragment>
		//			<h4 className="form-label">도서관 선택</h4>
		//			<p className="section-description">도서관 목록을 가져오는 중 ...</p><br/>
		//		</React.Fragment>
				
		//	)
		//	: this.dorender();

		return (
			<React.Fragment>
				<Header headerTitle={this.state.headerTitle}/>
                <br/><p/>
                <br/><p/>
                <br/><p/>
                <br/><p/>
                <br/><p/>
				<div className="signLayout">

					<div className="form-group">
						{contents}
					</div>

					<div className="form-group">
						<input className="form-input form-input-lg" type="text" id="userid" placeholder="도서관ID" onChange={this.handleUseridChange.bind(this)} />
						<input className="form-input form-input-lg" type="password" id="apsswd" placeholder="비밀번호" onChange={this.handleUserpasswdChange.bind(this)} />
						<Button variant="contained" fullWidth="true" className="btn-sign" onClick={this.signIn.bind(this)}>
							로그인
						</Button>
					</div>
					<div className="promocode">
						<Link to="/signup-promocode">프로모션 코드가 있습니다.</Link>
					</div>
				</div>
				<Dialog open={this.state.open} onClose={this.doCloseAlert}>
					<div className="dialog-body">
						<p>인증에 실패하였습니다.</p>
					</div>
					<div className="dialog-footer">
						<button onClick={this.doCloseAlert} color="primary" autoFocus className="btn btn-primary btn-sm">
							닫기
						</button>
						<br />
					</div>
				</Dialog>
			</React.Fragment>
		);
	}
}

export default Home;
